export const FailedVerificationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 357 231"
        >
            <g filter="url(#a)" opacity={0.05}>
                <rect
                    width={174.394}
                    height={104.637}
                    fill="#D43527"
                    rx={9}
                    transform="matrix(.86603 -.5 .86603 .5 70.974 132.795)"
                />
            </g>
            <path
                fill="#D9D9D9"
                d="M23.65 121.275c-1.33-.896-2.061-2.038-2.061-3.219v-2.361l8.125-4.965 12.194-7.04 24.388-14.08 48.776-28.161 90.625-52.323c3.826-2.209 10.03-2.209 13.856 0L322.76 68.713c3.827 2.21 3.827 5.79 0 8L143.243 180.357c-4.783 2.762-12.537 2.762-17.32 0l-101.92-58.843-.354-.239Z"
            />
            <path
                fill="#fff"
                stroke="#D9D9D9"
                d="M25.27 119.9c-4.072-2.35-4.072-6.161 0-8.511L204.767 7.756c4.071-2.35 10.671-2.35 14.742 0L320.964 66.33c4.071 2.35 4.071 6.161 0 8.511L141.467 178.475c-4.071 2.35-10.672 2.35-14.743 0L25.27 119.9Z"
            />
            <g fill="#394855" opacity={0.3}>
                <path d="M64.256 116.333c-1.774 1.089-1.774 2.787 0 3.876l16.817 10.322-17.772-10.26c-1.913-1.105-1.913-2.896 0-4l17.772-10.261-16.817 10.323ZM101.682 94.112l17.913-9.728c1.872-1.017 4.787-1.026 6.677-.02l12.732 6.774-12.622-7.287c-1.913-1.105-5.015-1.105-6.928 0l-17.772 10.26ZM169.912 108.983l11.765 7.371c1.729 1.083 1.729 2.75 0 3.833l-11.765 7.371 12.622-7.287c1.914-1.105 1.914-2.896 0-4l-12.622-7.288ZM139.004 145.403l-12.732 6.774c-1.89 1.006-4.805.997-6.677-.019l-17.913-9.728 17.772 10.26c1.913 1.105 5.015 1.105 6.928 0l12.622-7.287Z" />
            </g>
            <g fill="#394855" opacity={0.3}>
                <path d="M116.467 124.919c-3.808 2.198-5.947 5.18-5.947 8.289s2.139 6.09 5.947 8.289c1.838 1.061 4.351 1.646 6.849 1.231 4.77-.793 13.541-3.056 24.736-9.52 11.196-6.464 15.116-11.528 16.489-14.282.719-1.442-.293-2.893-2.131-3.954-3.808-2.199-8.973-3.434-14.358-3.434s-10.549 1.235-14.357 3.434l-17.228 9.947ZM130.326 109.189c-.783-2.274-2.717-4.362-5.556-6.002-3.808-2.198-8.973-3.433-14.357-3.433-5.385 0-10.55 1.235-14.358 3.433-2.84 1.64-4.773 3.728-5.556 6.002-.784 2.274-.382 4.631 1.155 6.773 1.537 2.142 4.14 3.973 7.478 5.261 3.339 1.288 7.265 1.976 11.281 1.976 4.015 0 7.941-.688 11.28-1.976 3.339-1.288 5.941-3.119 7.478-5.261s1.939-4.499 1.155-6.773Z" />
            </g>
            <g fill="#394855" opacity={0.1}>
                <path d="M145.832 71.65c-2.079-1.2-2.079-3.147 0-4.348l56.485-32.612c2.08-1.2 5.452-1.2 7.532 0s2.08 3.148 0 4.348L153.364 71.65c-2.08 1.2-5.452 1.2-7.532 0ZM163.719 81.977c-2.079-1.2-2.079-3.147 0-4.348l72.49-41.852c2.079-1.2 5.451-1.2 7.531 0s2.08 3.148 0 4.348l-72.489 41.852c-2.08 1.2-5.452 1.2-7.532 0ZM181.5 87.895c-2.079 1.2-2.079 3.147 0 4.348 2.08 1.2 5.452 1.2 7.532 0l41.422-23.915c2.08-1.201 2.08-3.148 0-4.349-2.079-1.2-5.451-1.2-7.531 0L181.5 87.895Z" />
            </g>
            <g filter="url(#b)" opacity={0.4}>
                <path
                    fill="#D43527"
                    d="M266.324 63.758c-1.326-2.646 2.92-5.097 7.503-4.332 3.195.534 6.539-.52 7.489-2.36 1.362-2.64 7.229-3.377 10.367-1.303 2.189 1.447 5.988 1.604 8.511.352 3.618-1.796 9.243-.584 9.941 2.14.487 1.9 3.536 3.218 6.831 2.953 4.724-.382 8.323 2.394 6.358 4.903-1.37 1.75-.038 3.811 2.982 4.616 4.332 1.154 4.76 4.612.757 6.11-2.791 1.045-3.601 3.194-1.814 4.814 2.563 2.323-.314 5.365-5.085 5.376-3.326.008-6.02 1.563-6.033 3.484-.019 2.754-5.289 4.415-9.312 2.936-2.806-1.032-6.528-.565-8.338 1.047-2.595 2.31-8.584 2.064-10.583-.437-1.394-1.744-4.963-2.513-7.995-1.722-4.347 1.134-9.154-.943-8.493-3.67.46-1.903-1.823-3.664-5.114-3.945-4.719-.402-6.817-3.65-3.708-5.74 2.169-1.456 1.897-3.65-.608-4.913-3.593-1.812-2.317-5.2 2.255-5.986 3.188-.548 5.014-2.478 4.089-4.323Z"
                />
            </g>
            <path
                fill="#D43527"
                d="M262.164 53.549c-1.452-2.898 3.197-5.582 8.216-4.744l.847.142c3.499.584 7.16-.57 8.2-2.585l.252-.488c1.492-2.89 7.917-3.698 11.354-1.426l.58.383c2.396 1.584 6.557 1.756 9.32.385l.668-.332c3.962-1.966 10.122-.64 10.887 2.344l.129.504c.532 2.08 3.872 3.524 7.48 3.233l.873-.07c5.174-.418 9.114 2.621 6.963 5.37l-.363.463c-1.5 1.917-.043 4.174 3.265 5.055l.801.213c4.743 1.264 5.212 5.05.829 6.691l-.74.277c-3.057 1.145-3.944 3.498-1.987 5.272l.474.43c2.807 2.543-.344 5.875-5.568 5.887l-.882.002c-3.643.008-6.592 1.711-6.607 3.814l-.003.51c-.021 3.015-5.792 4.835-10.198 3.214l-.744-.273c-3.072-1.13-7.148-.618-9.13 1.146l-.48.428c-2.841 2.53-9.4 2.26-11.589-.479l-.369-.462c-1.527-1.91-5.435-2.752-8.755-1.885l-.804.21c-4.76 1.241-10.024-1.034-9.301-4.02l.122-.505c.504-2.083-1.996-4.011-5.599-4.319l-.873-.074c-5.168-.441-7.465-3.998-4.06-6.285l.575-.386c2.374-1.595 2.077-3.998-.667-5.381l-.664-.335c-3.934-1.984-2.537-5.694 2.47-6.555l.845-.145c3.491-.601 5.49-2.715 4.478-4.735l-.245-.49Z"
            />
            <rect width={4.899} height={28.284} x={290.495} y={52.414} fill="#fff" rx={2} />
            <rect
                width={2.828}
                height={48.99}
                x={317.439}
                y={65.142}
                fill="#fff"
                rx={2}
                transform="rotate(90 317.439 65.142)"
            />
            <defs>
                <filter
                    id="a"
                    width={328.517}
                    height={230.243}
                    x={27.539}
                    y={0.234}
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_2075_766" stdDeviation={24} />
                </filter>
                <filter
                    id="b"
                    width={83.921}
                    height={53.524}
                    x={251.904}
                    y={48.565}
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_2075_766" stdDeviation={3} />
                </filter>
            </defs>
        </svg>
    );
};
